import { Status } from '../../interfaces';

export const isStatusType: (value: unknown) => value is Status = (value: unknown): value is Status => {
  const statusKeys: string[] = [
    'label',
    'color',
    'background',
    'border',
  ];
  const statusValue: Status = value as Status;

  return (
    typeof value === 'object'
    && Object.keys(value as Record<string, unknown>).every((key: string): boolean => statusKeys.includes(key))
    && !!statusValue.label
    && !!statusValue.color
  );
};
